import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
// The categories.json file is already configured to be cached by the browser, but for this sampling
// config, it's even less important to manage stale values. Most BSC API interaction is done on
// application startup.  So we may as well cache this in memory once per app load and not retrieve
// it from local disk for each event emitted.
export var CachedSamplingConfig = /*#__PURE__*/function () {
  function CachedSamplingConfig() {
    _classCallCheck(this, CachedSamplingConfig);
  }
  return _createClass(CachedSamplingConfig, [{
    key: "cachedSamplingConfig",
    get: function get() {
      return this.cache;
    },
    set: function set(value) {
      this.cache = value;
    }
  }]);
}();